// Ticket 909: genereert per gekozen vakantiedag een urenveld zodra de
// van/tot-datums zijn ingevuld (decimalen toegestaan, bv. 2,5).
// #1633 vervolg: per dag ook van/tot. Bij een deel van een dag (meer dan 0 en
// minder dan een volle werkdag) zijn die verplicht; dan blokkeert het verlof alleen dat
// tijdsblok in het rooster. Van en tot ingevuld met lege uren vult de uren.
// Bugfix 14 vervolg (#1349): een keuze per dag of alleen het totaal. Bij een
// totaal verdeelt de server het naar rato over de werkdagen
// (VacationRequest.verdeel_totaal). De velden van de andere keuze gaan uit,
// zodat ze niet meegestuurd worden.
// 1349 (Sam, 19-10): de vrije feestdagen van het bedrijf (data-vacation-days-vrij,
// { "2026-12-25": "Eerste Kerstdag" }) tellen niet als werkdag, net als op de
// server; per dag staat de naam erbij.
// 1349 (Sam, 20-10): "een gesloten dag moet niet mee tellen als vakantie dag".
// De dagen dat het hele bedrijf dicht is (data-vacation-days-gesloten) krijgen
// nooit uren: niet bij het verdelen en per dag staat het veld uit.
// 1349 (Sam, 20-10): een volle werkdag is per medewerker in te stellen
// (data-vacation-days-volle-dag, standaard 8). Kiest een beheerder een collega
// in Nieuwe registratie, dan geldt die van de collega (data-vacation-days-volle-dagen,
// { "12": 6 }).
import { Controller } from "stimulus"

const STANDAARD_VOLLE_DAG = 8

export default class extends Controller {
  static targets = ["start", "end", "days"]

  connect() {
    this.modus = "dag"
    this.uid = Math.random().toString(36).slice(2, 8)
    try {
      this.vrij = JSON.parse(this.data.get("vrij") || "{}") || {}
    } catch (e) {
      this.vrij = {}
    }
    try {
      this.gesloten = JSON.parse(this.data.get("gesloten") || "{}") || {}
    } catch (e) {
      this.gesloten = {}
    }
    try {
      this.volleDagen = JSON.parse(this.data.get("volleDagen") || "{}") || {}
    } catch (e) {
      this.volleDagen = {}
    }
    this.medewerkerKeuze = this.element.querySelector("[data-medewerker-select]")
    if (this.medewerkerKeuze) {
      this.medewerkerKeuze.addEventListener("change", () => {
        if (!this.dagenBlok) return
        this.dagenBlok.querySelectorAll("[data-vakantie-dag]:not([data-gesloten])").forEach((row) => this.toonTijden(row))
      })
    }
  }

  // De uren van een volle werkdag van de medewerker voor wie het verlof is
  volleDag() {
    const gekozen = this.medewerkerKeuze && this.volleDagen[this.medewerkerKeuze.value]
    const eigen = parseFloat(this.data.get("volleDag"))
    const uren = parseFloat(gekozen) || eigen
    return uren > 0 ? uren : STANDAARD_VOLLE_DAG
  }

  isGesloten(day) {
    return Boolean(this.gesloten[day.toISOString().slice(0, 10)])
  }

  isWeekdag(day) {
    return day.getDay() !== 0 && day.getDay() !== 6 && !this.isGesloten(day)
  }

  // Een werkdag voor de verdeling: maandag tot en met vrijdag, geen vrije feestdag
  isWerkdag(day) {
    const iso = day.toISOString().slice(0, 10)
    return this.isWeekdag(day) && !this.vrij[iso]
  }

  rebuild() {
    const start = this.startTarget.value
    const end = this.endTarget.value
    this.daysTarget.innerHTML = ""
    if (!start || !end || end < start) return

    const startDate = new Date(start + "T12:00:00")
    const endDate = new Date(end + "T12:00:00")
    const dagen = ["zo", "ma", "di", "wo", "do", "vr", "za"]
    const vanLabel = this.data.get("van") || "van"
    const totLabel = this.data.get("tot") || "tot"

    this.daysTarget.appendChild(this.keuzeBalk())
    this.dagenBlok = document.createElement("div")
    this.dagenBlok.dataset.invoerDagen = ""
    this.daysTarget.appendChild(this.dagenBlok)

    let day = startDate
    let count = 0
    this.werkdagen = 0
    this.weekdagen = 0
    while (day <= endDate && count < 62) {
      const iso = day.toISOString().slice(0, 10)
      if (this.isWeekdag(day)) this.weekdagen++
      if (this.isWerkdag(day)) this.werkdagen++
      const label = `${dagen[day.getDay()]} ${String(day.getDate()).padStart(2, "0")}-${String(day.getMonth() + 1).padStart(2, "0")}`
      const vrijLabel = this.data.get("vrijLabel") || "vrije feestdag"
      const feestdag = this.vrij[iso]
        ? `<span class="text-xs text-taupe-600" data-vrije-feestdag title="${vrijLabel}">${this.escape(this.vrij[iso])}</span>`
        : ""
      const gesloten = this.gesloten[iso]
        ? `<span class="text-xs text-taupe-600" data-gesloten-dag>${this.escape(this.gesloten[iso])}</span>`
        : ""
      const row = document.createElement("div")
      row.className = "flex flex-wrap items-center gap-2"
      row.dataset.vakantieDag = iso
      if (this.gesloten[iso]) row.dataset.gesloten = ""
      row.innerHTML = `
        <span class="text-xs text-taupe-600 w-16">${label}</span>
        <input type="number" step="0.5" min="0" max="24" name="vacation_request[day_hours][${iso}]"
               placeholder="uren" class="w-20 rounded-md border-line shadow-sm text-sm px-2 py-1" data-uren>
        <span class="text-xs text-taupe-600">uur</span>
        ${feestdag}${gesloten}
        <label class="text-xs text-taupe-600 hidden" data-tijden>${vanLabel}
          <input type="time" name="vacation_request[day_times][${iso}][van]" class="rounded-md border-line shadow-sm text-sm px-1 py-1" data-van>
        </label>
        <label class="text-xs text-taupe-600 hidden" data-tijden>${totLabel}
          <input type="time" name="vacation_request[day_times][${iso}][tot]" class="rounded-md border-line shadow-sm text-sm px-1 py-1" data-tot>
        </label>`
      row.querySelector("[data-uren]").addEventListener("input", () => this.toonTijden(row))
      row.querySelectorAll("[data-van], [data-tot]").forEach((veld) => veld.addEventListener("change", () => this.vulUren(row)))
      this.dagenBlok.appendChild(row)
      day = new Date(day.getTime() + 86400000)
      count++
    }
    // Ook na de 62 getoonde dagen tellen de werkdagen mee voor de hint
    while (day <= endDate) {
      if (this.isWeekdag(day)) this.weekdagen++
      if (this.isWerkdag(day)) this.werkdagen++
      day = new Date(day.getTime() + 86400000)
    }
    // Zoals de server: valt alles op vrije feestdagen, dan over de weekdagen
    if (this.werkdagen === 0) this.werkdagen = this.weekdagen

    this.daysTarget.appendChild(this.totaalBlok())
    this.daysTarget.classList.remove("hidden")
    this.toonModus()
  }

  // Twee keuzes: per dag of alleen het totaal. De keuze gaat als
  // vacation_request[invoer] mee naar de server.
  keuzeBalk() {
    const balk = document.createElement("div")
    balk.dataset.invoerKeuze = ""
    balk.setAttribute("role", "radiogroup")
    balk.setAttribute("aria-label", this.data.get("keuze") || "Invoer")
    balk.className = "flex flex-wrap items-center gap-3 text-sm"
    balk.style.gridColumn = "1 / -1"
    const opties = [["dag", this.data.get("perDag") || "Per dag"], ["totaal", this.data.get("totaal") || "Alleen het totaal"]]
    opties.forEach(([waarde, tekst]) => {
      const label = document.createElement("label")
      label.className = "inline-flex items-center gap-1.5"
      label.style.cursor = "pointer"
      const radio = document.createElement("input")
      radio.type = "radio"
      radio.name = "vacation_request[invoer]"
      radio.value = waarde
      radio.id = `vd-invoer-${waarde}-${this.uid}`
      radio.checked = this.modus === waarde
      radio.dataset.invoer = waarde
      radio.addEventListener("change", () => {
        this.modus = waarde
        this.toonModus()
      })
      label.appendChild(radio)
      label.appendChild(document.createTextNode(` ${tekst}`))
      balk.appendChild(label)
    })
    return balk
  }

  totaalBlok() {
    const blok = document.createElement("div")
    blok.dataset.invoerTotaal = ""
    blok.className = "flex flex-wrap items-center gap-2"
    blok.style.gridColumn = "1 / -1"
    const id = `vd-totaal-${this.uid}`
    const hulp = (this.data.get("totaalHulp") || "Verdeeld over %{werkdagen} werkdagen.").replace("%{werkdagen}", this.werkdagen)
    blok.innerHTML = `
      <label class="text-xs text-taupe-600" for="${id}">${this.data.get("totaalLabel") || "Totaal"}</label>
      <input type="number" step="0.25" min="0.25" name="vacation_request[totaal_uren]" id="${id}"
             class="w-24 rounded-md border-line shadow-sm text-sm px-2 py-1" data-totaal-uren>
      <span class="text-xs text-taupe-600">${this.data.get("uur") || "uur"}</span>
      <span class="text-xs text-taupe-600" style="flex-basis:100%" data-totaal-hulp>${hulp}</span>`
    return blok
  }

  // Alleen de velden van de gekozen invoer staan aan en gaan mee
  toonModus() {
    const totaal = this.modus === "totaal"
    const blok = this.daysTarget.querySelector("[data-invoer-totaal]")
    if (!blok || !this.dagenBlok) return

    blok.style.display = totaal ? "" : "none"
    blok.querySelectorAll("input").forEach((veld) => {
      veld.disabled = !totaal
      veld.required = totaal
    })
    // display: contents houdt de rijen in het raster van de welkomstpagina
    this.dagenBlok.style.display = totaal ? "none" : "contents"
    this.dagenBlok.querySelectorAll("input").forEach((veld) => {
      veld.disabled = totaal || Boolean(veld.closest("[data-gesloten]"))
    })
    if (!totaal) this.dagenBlok.querySelectorAll("[data-vakantie-dag]:not([data-gesloten])").forEach((row) => this.toonTijden(row))
  }

  // Bij een deel van een dag de tijden tonen en verplicht maken
  toonTijden(row) {
    const uren = parseFloat(String(row.querySelector("[data-uren]").value).replace(",", "."))
    const deel = uren > 0 && uren < this.volleDag()
    row.querySelectorAll("[data-tijden]").forEach((label) => label.classList.toggle("hidden", !deel && !this.tijdIngevuld(row)))
    row.querySelectorAll("[data-van], [data-tot]").forEach((veld) => { veld.required = deel })
  }

  vulUren(row) {
    const uren = row.querySelector("[data-uren]")
    const van = row.querySelector("[data-van]").value
    const tot = row.querySelector("[data-tot]").value
    if (!van || !tot || uren.value) return

    const minuten = (tekst) => parseInt(tekst.slice(0, 2), 10) * 60 + parseInt(tekst.slice(3, 5), 10)
    const verschil = minuten(tot) - minuten(van)
    if (verschil > 0) uren.value = Math.round((verschil / 60) * 2) / 2
  }

  tijdIngevuld(row) {
    return Boolean(row.querySelector("[data-van]").value || row.querySelector("[data-tot]").value)
  }

  escape(tekst) {
    const div = document.createElement("div")
    div.textContent = tekst
    return div.innerHTML
  }
}
